export default "__VITE_ASSET__ukcM0ddz__"